import { api } from "../client";
import {
  PriceIndividualExtraFields,
  PriceIndividualFields,
  PartialPriceIndividualExtraFields,
  PartialPriceIndividualFields,
} from "../schema/PriceIndividual";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  PriceIndividualFields,
  PriceIndividualExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialPriceIndividualFields,
  PartialPriceIndividualExtraFields
>;

export const getPriceIndividuals = async (config?: ApiRequestConfig) => {
  return api.get<PriceIndividualFields, PriceIndividualExtraFields>(
    "price_individuals",
    config
  );
};
export const getPriceIndividual = (id: number, config?: ApiRequestConfig) => {
  return api.get<PriceIndividualFields, PriceIndividualExtraFields>(
    `price_individuals/${id}`,
    config
  );
};

export const createPriceIndividual = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialPriceIndividualFields,
    PartialPriceIndividualExtraFields
  >("price_individuals", config);
};
export const updatePriceIndividual = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialPriceIndividualFields,
    PartialPriceIndividualExtraFields
  >(`price_individuals/${id}`, config);
};
export const deletePriceIndividual = (id: number) => {
  return api.remove<PriceIndividualFields, PriceIndividualExtraFields>(
    `price_individuals/${id}`
  );
};
